import { Messages } from "../../types/messages";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";

export const fetchBookingMessages = async (
  bookingId?: string
): Promise<Messages[] | undefined> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const headerParams = {
    source: "admin"
  };
  const paramsObj = {
    booking_id: `${bookingId}`,
    app_name: "com.collins.mobile",
    ...headerParams
  };
  const searchParams = new URLSearchParams(paramsObj);

  return await fetch(
    `${environmentVars?.CORE_API_BASE_URL}/messages?${searchParams.toString()}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        ...headerParams
      }
    }
  )
    .then(async (response) => {
      if (!response.ok) {
        apiFetchNotOkHandler(response, "Error fetching messages");
        return [];
      }

      return (await response.json()).payload?.messages ?? [];
    })
    .catch((error) => {
      errorHandler(error, "Error fetching messages");

      return [];
    });
};
